import { MaskedLine, FadeUp } from "./Reveal";

const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="relative bg-mist py-28 lg:py-40 overflow-hidden"
  >
    <img
      src="/assets/lotus-line.png"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -bottom-8 -left-8 w-48 lg:w-64 opacity-[0.10] animate-float-soft"
    />

    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <FadeUp>
            <p className="uppercase tracking-[0.28em] text-xs sm:text-sm font-bold text-peri flex items-center gap-3">
              <span className="inline-block w-10 h-px bg-peri" />
              About Us
            </p>
          </FadeUp>

          <h2
            data-testid="about-heading"
            className="mt-10 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.12] tracking-tight text-navy"
          >
            <MaskedLine delay={0.1}>Grounded in Value.</MaskedLine>
            <MaskedLine delay={0.22}>
              <span className="text-grad">Built for Scale.</span>
            </MaskedLine>
          </h2>

          <FadeUp delay={0.35}>
            <p
              data-testid="about-body"
              className="mt-8 text-base sm:text-lg leading-relaxed text-navy/70 border-l-2 border-peri/40 pl-6"
            >
              At Kritajna Ventures LLP, we synthesize technology, physical real estate, and
              strategic trade to build sustainable, long-term enterprise value. Guided by
              financial discipline and operationally sound leadership, our portfolio spans
              cloud-based software platforms, commercial property leasing, and dynamic retail
              trading networks. We partner with operational operators and businesses to deliver
              high-utility assets and modern digital tools.
            </p>
          </FadeUp>

          <FadeUp delay={0.5}>
            <p
              data-testid="about-phonetic"
              className="mt-8 flex items-center gap-3 text-sm sm:text-base font-semibold text-navy/80"
            >
              <img src="/assets/lotus-icon.png" alt="" aria-hidden="true" className="w-6 h-6 object-contain" />
              Kritajna <span className="text-peri">(Kri-taj-na)</span> — Grounded in gratitude.
            </p>
          </FadeUp>
        </div>

        <FadeUp delay={0.3} className="flex items-center justify-center lg:justify-end">
          <img
            src="/assets/logo-ml.png"
            alt="കൃതജ്ഞ Ventures LLP — Kritajna in Malayalam"
            data-testid="about-malayalam-logo"
            className="w-full max-w-xl object-contain"
          />
        </FadeUp>
      </div>
    </div>
  </section>
);

export default About;
